import { useTranslation } from 'libs/i18n'
import { useContext } from 'react'
import { StoreSettingsContext } from 'store'

export const useSortingFilters = () => {
	const { t } = useTranslation()
	const storeCtx = useContext(StoreSettingsContext)

	return {
		id: 'ordering',
		label: t('Sort by'),
		placeholder: t('Default'),
		options: [
			{
				value: 'name',
				label: `${t('Name')} asc`
			},
			{
				value: '-name',
				label: `${t('Name')} desc`
			},
			...(storeCtx?.storeSettings?.categories_enabled
				? [
						{
							value: 'category',
							label: `${t('Category')} asc`
						},
						{
							value: '-category',
							label: `${t('Category')} desc`
						}
					]
				: []),
			{
				value: 'published',
				label: `${t('Published')} asc`
			},
			{
				value: '-published',
				label: `${t('Published')} desc`
			},
			{
				value: 'booking__booth',
				label: `${t('Booking')} asc`
			},
			{
				value: '-booking__booth',
				label: `${t('Booking')} desc`
			},
			{
				value: 'price',
				label: `${t('Price')} asc`
			},
			{
				value: '-price',
				label: `${t('Price')} desc`
			},
			{
				value: 'updated',
				label: `${t('Last modified')} asc`
			},
			{
				value: '-updated',
				label: `${t('Last modified')} desc`
			}
		]
	}
}
